import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

// api
import baseApi from "../../api/baseApi";

// diğer importlar
import { Slide, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const toastConfig = {
  isLoading: false,
  autoClose: 5000,
  transition: Slide,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
};

const initialState = {
  order: {},
  orderLoading: true,
  orderRefresh: true,

  orders: [],
  ordersLoading: true,
  ordersRefresh: true,

  requestPayments: [],
  requestPaymentsLoading: true,
  requestPaymentsRefresh: true,

  couponPayments: [],
  couponPaymentsLoading: true,
  couponPaymentsRefresh: true,

  primPayments: [],
  primPaymentsLoading: true,
  primPaymentsRefresh: true,

  primPaymentCustomers: [],
  primPaymentCustomersLoading: true,
  primPaymentCustomersRefresh: true,

  servicesByCompany: [],
  servicesByCompanyLoading: true,
  servicesByCompanyRefresh: true,

  couponsByCompany: [],
  couponsByCompanyLoading: true,
  couponsByCompanyRefresh: true,

  primsByCompany: [],
  primsByCompanyLoading: true,
  primsByCompanyRefresh: true,

  createOrderLoading: false,
  updateOrderLoading: false,
  deleteOrderLoading: false,
  confirmRequestPaymentLoading: false,
  confirmCouponPaymentLoading: false,
  requestCouponPaymentsLoading: false,
  confirmPrimPaymentLoading: false,
};

export const fetchOrder = createAsyncThunk("order/fetchOrder", async (id) => {
  if (!id) {
    const errMsg = "Id bulunamadı!";

    toast.error(errMsg, {
      ...toastConfig,
    });

    throw new Error(errMsg);
  }

  try {
    const response = await baseApi.get(`/Orders/${id}`);

    return response.data.result;
  } catch (error) {
    const errMsg =
      error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

    toast.error(errMsg, {
      ...toastConfig,
    });

    throw new Error(errMsg);
  }
});

export const fetchOrders = createAsyncThunk("order/fetchOrders", async () => {
  try {
    const response = await baseApi.get(`/Orders`);

    return response.data.result;
  } catch (error) {
    const errMsg =
      error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

    toast.error(errMsg, {
      ...toastConfig,
    });

    throw new Error(errMsg);
  }
});

export const fetchRequestPayments = createAsyncThunk(
  "order/fetchRequestPayments",
  async () => {
    try {
      const response = await baseApi.get(`/Orders/GetRequestPayments`);

      return response.data.result;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const fetchRequestPaymentsByCompany = createAsyncThunk(
  "order/fetchRequestPaymentsByCompany",
  async () => {
    try {
      const response = await baseApi.get(`/Orders/GetRequestPaymentsByCompany`);

      return response.data.result;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const fetchCouponPayments = createAsyncThunk(
  "order/fetchCouponPayments",
  async () => {
    try {
      const response = await baseApi.get(`/Orders/GetCouponPayments`);

      return response.data.result;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const fetchCouponPaymentsByCompany = createAsyncThunk(
  "order/fetchCouponPaymentsByCompany",
  async () => {
    try {
      const response = await baseApi.get(`/Orders/GetCouponPaymentsByCompany`);

      return response.data.result;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const fetchPrimPayments = createAsyncThunk(
  "order/fetchPrimPayments",
  async () => {
    try {
      const response = await baseApi.get(`/Orders/GetPrimPayments`);

      return response.data.result;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const fetchPrimPaymentsByCompany = createAsyncThunk(
  "order/fetchPrimPaymentsByCompany",
  async () => {
    try {
      const response = await baseApi.get(`/Orders/GetPrimPaymentsByCompany`);

      return response.data.result;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const fetchPrimPaymentCustomers = createAsyncThunk(
  "order/fetchPrimPaymentCustomers",
  async (id) => {
    if (!id) {
      const errMsg = "Id bulunamadı!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }

    try {
      const response = await baseApi.get(`/Orders/GetPrimPaymentDetails/${id}`);

      return response.data.result;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const fetchPrimPaymentCustomersByCompany = createAsyncThunk(
  "order/fetchPrimPaymentCustomersByCompany",
  async (id) => {
    if (!id) {
      const errMsg = "Id bulunamadı!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }

    try {
      const response = await baseApi.get(
        `/Orders/GetPrimPaymentDetailsByCompany/${id}`
      );

      return response.data.result;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const confirmRequestPayment = createAsyncThunk(
  "order/confirmRequestPayment",
  async (values) => {
    if (!values) {
      const errMsg = "Veri bulunamadı!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }

    const loadingToast = toast.loading("Kaydediliyor...", {
      transition: Slide,
    });

    try {
      const response = await baseApi.post(
        `/Orders/ConfirmPayment/${values.id}?description=${values.description}`
      );

      toast.update(loadingToast, {
        render: "İşlem Tamamlandı.",
        type: "success",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
      });

      return response.data;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.update(loadingToast, {
        render: errMsg,
        type: "error",
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const confirmCouponPayment = createAsyncThunk(
  "order/confirmCouponPayment",
  async (values) => {
    if (!values) {
      const errMsg = "Veri bulunamadı!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }

    const loadingToast = toast.loading("Kaydediliyor...", {
      transition: Slide,
    });

    try {
      const response = await baseApi.post(
        `/Orders/ConfirmCouponPayment/${values.id}?description=${values.description}`
      );

      toast.update(loadingToast, {
        render: "İşlem Tamamlandı.",
        type: "success",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
      });

      return response.data;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.update(loadingToast, {
        render: errMsg,
        type: "error",
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const confirmPrimPayment = createAsyncThunk(
  "order/confirmPrimPayment",
  async (values) => {
    if (!values) {
      const errMsg = "Veri bulunamadı!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }

    const loadingToast = toast.loading("Kaydediliyor...", {
      transition: Slide,
    });

    try {
      const response = await baseApi.post(
        `/Orders/ConfirmPrimPayment/${values.id}?description=${values.description}`
      );

      toast.update(loadingToast, {
        render: "İşlem Tamamlandı.",
        type: "success",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
      });

      return response.data;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.update(loadingToast, {
        render: errMsg,
        type: "error",
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const fetchServicesByCompany = createAsyncThunk(
  "order/fetchServicesByCompany",
  async (id) => {
    if (!id) {
      const errMsg = "Id bulunamadı!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }

    try {
      const response = await baseApi.get(`/Orders/GetServicesByCompany/${id}`);

      return response.data.result;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const fetchCouponsByCompany = createAsyncThunk(
  "order/fetchCouponsByCompany",
  async (id) => {
    if (!id) {
      const errMsg = "Id bulunamadı!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }

    try {
      const response = await baseApi.get(`/Orders/GetCouponsByCompany/${id}`);

      return response.data.result;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const fetchPrimsByCompany = createAsyncThunk(
  "order/fetchPrimsByCompany",
  async (id) => {
    if (!id) {
      const errMsg = "Id bulunamadı!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }

    try {
      const response = await baseApi.get(`/Orders/GetPrimsByCompany/${id}`);

      return response.data.result;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const requestPayments = createAsyncThunk(
  "order/requestPayments",
  async (values) => {
    if (!values || values?.length == 0) {
      const errMsg = "Veri bulunamadı!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }

    const loadingToast = toast.loading("Kaydediliyor...", {
      transition: Slide,
    });

    try {
      const response = await baseApi.post(`/Orders/RequestPayments`, values);

      toast.update(loadingToast, {
        render: "İşlem Tamamlandı.",
        type: "success",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
      });

      return response.data;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.update(loadingToast, {
        render: errMsg,
        type: "error",
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const requestCouponPayments = createAsyncThunk(
  "order/requestCouponPayments",
  async (values) => {
    if (!values || values?.length == 0) {
      const errMsg = "Veri bulunamadı!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }

    const loadingToast = toast.loading("Kaydediliyor...", {
      transition: Slide,
    });

    try {
      const response = await baseApi.post(
        `/Orders/RequestCouponPayments`,
        values
      );

      toast.update(loadingToast, {
        render: "İşlem Tamamlandı.",
        type: "success",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
      });

      return response.data;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.update(loadingToast, {
        render: errMsg,
        type: "error",
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const createOrder = createAsyncThunk(
  "order/createOrder",
  async (values) => {
    if (!values) {
      const errMsg = "Veri bulunamadı!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }

    const data = {
      customerId: values.customerId,
      workOrderCode: values.workOrderCode,
      couponAmount: parseInt(values.couponAmount),
      orderDetails: values.orderDetails,
    };

    const loadingToast = toast.loading("Kaydediliyor...", {
      transition: Slide,
    });

    try {
      const response = await baseApi.post(`/Orders`, data);

      toast.update(loadingToast, {
        render: "İşlem Tamamlandı.",
        type: "success",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
      });

      return response.data;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.update(loadingToast, {
        render: errMsg,
        type: "error",
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const updateOrder = createAsyncThunk(
  "order/updateOrder",
  async (values) => {
    if (!values) {
      const errMsg = "Veri bulunamadı!";
      toast.error(errMsg, { ...toastConfig });
      throw new Error(errMsg);
    }

    const data = {
      id: values.id,
      workOrderCode: values.workOrderCode,
      couponAmount: Number(values.couponAmount) || 0,
      isPaid: !!values.isPaid,
      isPayRequested: !!values.isPayRequested,
      commissionFee: Number(values.commissionFee) || 0,
      totalDiscount: Number(values.totalDiscount) || 0,
      orderDetails: values.orderDetails,
    };

    const loadingToast = toast.loading("Güncelleniyor...", {
      transition: Slide,
    });

    try {
      const response = await baseApi.put(`/Orders/${values.id}`, data);

      toast.update(loadingToast, {
        render: "İşlem Tamamlandı.",
        type: "success",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
      });

      return response.data;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.update(loadingToast, {
        render: errMsg,
        type: "error",
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const deleteOrder = createAsyncThunk("order/deleteOrder", async (id) => {
  if (!id) {
    const errMsg = "Id bulunamadı!";

    toast.error(errMsg, {
      ...toastConfig,
    });

    throw new Error(errMsg);
  }

  const loadingToast = toast.loading("Siliniyor...", {
    transition: Slide,
  });

  try {
    const response = await baseApi.delete(`/Orders/${id}`);

    toast.update(loadingToast, {
      render: "Silindi.",
      type: "success",
      isLoading: false,
      autoClose: 5000,
      transition: Slide,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
    });

    return response.data;
  } catch (error) {
    const errMsg =
      error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

    toast.update(loadingToast, {
      render: errMsg,
      type: "error",
      ...toastConfig,
    });

    throw new Error(errMsg);
  }
});

export const orderSlice = createSlice({
  name: "order",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrder.pending, (state, action) => {
        state.orderLoading = true;
        state.order = {};
      })
      .addCase(fetchOrder.fulfilled, (state, action) => {
        state.order = action.payload;
        state.orderLoading = false;
      })
      .addCase(fetchOrder.rejected, (state, action) => {
        state.order = {};
        state.orderLoading = false;
      });

    builder
      .addCase(fetchOrders.pending, (state, action) => {
        state.ordersLoading = true;
        state.orders = [];
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        state.orders = action.payload;
        state.ordersLoading = false;
      })
      .addCase(fetchOrders.rejected, (state, action) => {
        state.orders = [];
        state.ordersLoading = false;
      });

    builder
      .addCase(fetchRequestPayments.pending, (state, action) => {
        state.requestPaymentsLoading = true;
        state.requestPayments = [];
      })
      .addCase(fetchRequestPayments.fulfilled, (state, action) => {
        state.requestPayments = action.payload;
        state.requestPaymentsLoading = false;
      })
      .addCase(fetchRequestPayments.rejected, (state, action) => {
        state.requestPayments = [];
        state.requestPaymentsLoading = false;
      });

    builder
      .addCase(fetchRequestPaymentsByCompany.pending, (state, action) => {
        state.requestPaymentsLoading = true;
        state.requestPayments = [];
      })
      .addCase(fetchRequestPaymentsByCompany.fulfilled, (state, action) => {
        state.requestPayments = action.payload;
        state.requestPaymentsLoading = false;
      })
      .addCase(fetchRequestPaymentsByCompany.rejected, (state, action) => {
        state.requestPayments = [];
        state.requestPaymentsLoading = false;
      });

    builder
      .addCase(fetchCouponPayments.pending, (state, action) => {
        state.couponPaymentsLoading = true;
        state.couponPayments = [];
      })
      .addCase(fetchCouponPayments.fulfilled, (state, action) => {
        state.couponPayments = action.payload;
        state.couponPaymentsLoading = false;
      })
      .addCase(fetchCouponPayments.rejected, (state, action) => {
        state.couponPayments = [];
        state.couponPaymentsLoading = false;
      });

    builder
      .addCase(fetchCouponPaymentsByCompany.pending, (state, action) => {
        state.couponPaymentsLoading = true;
        state.couponPayments = [];
      })
      .addCase(fetchCouponPaymentsByCompany.fulfilled, (state, action) => {
        state.couponPayments = action.payload;
        state.couponPaymentsLoading = false;
      })
      .addCase(fetchCouponPaymentsByCompany.rejected, (state, action) => {
        state.couponPayments = [];
        state.couponPaymentsLoading = false;
      });

    builder
      .addCase(fetchPrimPayments.pending, (state, action) => {
        state.primPaymentsLoading = true;
        state.primPayments = [];
      })
      .addCase(fetchPrimPayments.fulfilled, (state, action) => {
        state.primPayments = action.payload;
        state.primPaymentsLoading = false;
      })
      .addCase(fetchPrimPayments.rejected, (state, action) => {
        state.primPayments = [];
        state.primPaymentsLoading = false;
      });

    builder
      .addCase(fetchPrimPaymentsByCompany.pending, (state, action) => {
        state.primPaymentsLoading = true;
        state.primPayments = [];
      })
      .addCase(fetchPrimPaymentsByCompany.fulfilled, (state, action) => {
        state.primPayments = action.payload;
        state.primPaymentsLoading = false;
      })
      .addCase(fetchPrimPaymentsByCompany.rejected, (state, action) => {
        state.primPayments = [];
        state.primPaymentsLoading = false;
      });

    builder
      .addCase(fetchPrimPaymentCustomers.pending, (state, action) => {
        state.primPaymentCustomersLoading = true;
        state.primPaymentCustomers = [];
      })
      .addCase(fetchPrimPaymentCustomers.fulfilled, (state, action) => {
        state.primPaymentCustomers = action.payload;
        state.primPaymentCustomersLoading = false;
      })
      .addCase(fetchPrimPaymentCustomers.rejected, (state, action) => {
        state.primPaymentCustomers = [];
        state.primPaymentCustomersLoading = false;
      });

    builder
      .addCase(fetchPrimPaymentCustomersByCompany.pending, (state, action) => {
        state.primPaymentCustomersLoading = true;
        state.primPaymentCustomers = [];
      })
      .addCase(
        fetchPrimPaymentCustomersByCompany.fulfilled,
        (state, action) => {
          state.primPaymentCustomers = action.payload;
          state.primPaymentCustomersLoading = false;
        }
      )
      .addCase(fetchPrimPaymentCustomersByCompany.rejected, (state, action) => {
        state.primPaymentCustomers = [];
        state.primPaymentCustomersLoading = false;
      });

    builder
      .addCase(confirmRequestPayment.pending, (state, action) => {
        state.confirmRequestPaymentLoading = true;
      })
      .addCase(confirmRequestPayment.fulfilled, (state, action) => {
        state.confirmRequestPaymentLoading = false;
        state.requestPaymentsRefresh = !state.requestPaymentsRefresh;
      })
      .addCase(confirmRequestPayment.rejected, (state, action) => {
        state.confirmRequestPaymentLoading = false;
      });

    builder
      .addCase(confirmCouponPayment.pending, (state, action) => {
        state.confirmCouponPaymentLoading = true;
      })
      .addCase(confirmCouponPayment.fulfilled, (state, action) => {
        state.confirmCouponPaymentLoading = false;
        state.couponPaymentsRefresh = !state.couponPaymentsRefresh;
      })
      .addCase(confirmCouponPayment.rejected, (state, action) => {
        state.confirmCouponPaymentLoading = false;
      });

    builder
      .addCase(confirmPrimPayment.pending, (state, action) => {
        state.confirmPrimPaymentLoading = true;
      })
      .addCase(confirmPrimPayment.fulfilled, (state, action) => {
        state.confirmPrimPaymentLoading = false;
        state.primPaymentsRefresh = !state.primPaymentsRefresh;
      })
      .addCase(confirmPrimPayment.rejected, (state, action) => {
        state.confirmPrimPaymentLoading = false;
      });

    builder
      .addCase(fetchServicesByCompany.pending, (state, action) => {
        state.servicesByCompanyLoading = true;
        state.servicesByCompany = [];
      })
      .addCase(fetchServicesByCompany.fulfilled, (state, action) => {
        state.servicesByCompany = action.payload;
        state.servicesByCompanyLoading = false;
      })
      .addCase(fetchServicesByCompany.rejected, (state, action) => {
        state.servicesByCompany = [];
        state.servicesByCompanyLoading = false;
      });

    builder
      .addCase(fetchCouponsByCompany.pending, (state, action) => {
        state.couponsByCompanyLoading = true;
        state.couponsByCompany = [];
      })
      .addCase(fetchCouponsByCompany.fulfilled, (state, action) => {
        state.couponsByCompany = action.payload;
        state.couponsByCompanyLoading = false;
      })
      .addCase(fetchCouponsByCompany.rejected, (state, action) => {
        state.couponsByCompany = [];
        state.couponsByCompanyLoading = false;
      });

    builder
      .addCase(fetchPrimsByCompany.pending, (state, action) => {
        state.primsByCompanyLoading = true;
        state.primsByCompany = [];
      })
      .addCase(fetchPrimsByCompany.fulfilled, (state, action) => {
        state.primsByCompany = action.payload;
        state.primsByCompanyLoading = false;
      })
      .addCase(fetchPrimsByCompany.rejected, (state, action) => {
        state.primsByCompany = [];
        state.primsByCompanyLoading = false;
      });

    builder
      .addCase(createOrder.pending, (state, action) => {
        state.createOrderLoading = true;
      })
      .addCase(createOrder.fulfilled, (state, action) => {
        state.createOrderLoading = false;
        state.ordersRefresh = !state.ordersRefresh;
      })
      .addCase(createOrder.rejected, (state, action) => {
        state.createOrderLoading = false;
      });

    builder
      .addCase(requestPayments.pending, (state, action) => {
        state.requestPaymentsLoading = true;
      })
      .addCase(requestPayments.fulfilled, (state, action) => {
        state.requestPaymentsLoading = false;
        state.requestPaymentsRefresh = !state.requestPaymentsRefresh;
      })
      .addCase(requestPayments.rejected, (state, action) => {
        state.requestPaymentsLoading = false;
      });

    builder
      .addCase(requestCouponPayments.pending, (state, action) => {
        state.requestCouponPaymentsLoading = true;
      })
      .addCase(requestCouponPayments.fulfilled, (state, action) => {
        state.requestCouponPaymentsLoading = false;
        state.couponPaymentsRefresh = !state.couponPaymentsRefresh;
      })
      .addCase(requestCouponPayments.rejected, (state, action) => {
        state.requestCouponPaymentsLoading = false;
      });

    builder
      .addCase(updateOrder.pending, (state, action) => {
        state.updateOrderLoading = true;
      })
      .addCase(updateOrder.fulfilled, (state, action) => {
        state.updateOrderLoading = false;
        state.ordersRefresh = !state.ordersRefresh;
      })
      .addCase(updateOrder.rejected, (state, action) => {
        state.updateOrderLoading = false;
      });

    builder
      .addCase(deleteOrder.pending, (state, action) => {
        state.deleteOrderLoading = true;
      })
      .addCase(deleteOrder.fulfilled, (state, action) => {
        state.deleteOrderLoading = false;
        state.ordersRefresh = !state.ordersRefresh;
      })
      .addCase(deleteOrder.rejected, (state, action) => {
        state.deleteOrderLoading = false;
      });
  },
});

export default orderSlice.reducer;
